import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

import { Header } from 'ui/Header';

const SectionWrapper = styled.div`
  background-color: ${colors.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const SectionHeader = styled.div`
  padding: 0 32px;
  border-bottom: 1px solid ${colors.neutral20};
  background-color: ${colors.neutral5};
  display: flex;
  flex-flow: column;
`;

const SectionContent = styled.div`
  // overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 32px;
`;

type SectionLayoutProps = {
  title: string;
  headerContent?: React.ReactNode;
  titleAppendText?: JSX.Element;
};

const SectionLayout: React.FC<SectionLayoutProps> = ({
  children,
  headerContent,
  title,
  titleAppendText,
}) => (
  <SectionWrapper>
    <SectionHeader>
      <Header title={title} titleAppendText={titleAppendText} />
      {headerContent}
    </SectionHeader>
    <SectionContent>{children}</SectionContent>
  </SectionWrapper>
);

export default SectionLayout;
